import { adminHttpClient } from '../../../../commons/adminHttpClient'
import { BenefitStartDateValues } from '../common/models'

const postBenefitStartDateApi = (values: BenefitStartDateValues): Promise<string[]> => {
  return adminHttpClient.post('/AdminDashboard/Qsehra/BenefitDesign/BenefitStartDate', values)
}

export default postBenefitStartDateApi
